/* Purpose: Top Level navbar for any client page
 * Props: 
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React, {useState, useEffect} from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useLocation } from 'react-router-dom';

const Layout = () => {
    const lightLogo = require("../Images/iskaLogo.png")
    const location = useLocation();
    const [currentLocation, setCurrentLocation] = useState(location.pathname)
    useEffect(() => {
      setCurrentLocation(location.pathname)
    }, [location.pathname])
 
    return (
    <>
    <Navbar bg="dark" data-bs-theme="dark">
      <Container>
        <Navbar.Brand href="/">
                      <img
              src={lightLogo}
              width="100"
              height="40"
              className="d-inline-block align-top"
              alt="Iska Mortgage"
            />
        </Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link className = "m5" href="/">{currentLocation == "/"?<span className = "current-location">Home</span>:"Home"}</Nav.Link>
            <Nav.Link className = "m5" href="/Portal">{currentLocation !== "/"?(<span className = "current-location">Client Portal</span>):("Client Portal")}</Nav.Link>
          </Nav>
      </Container>
    </Navbar>
    </>      
    );
}

export default Layout;